<!--
  This icon is designed especially for Concertgebouw and not from an icon set,
  so be careful reusing it in other projects.
  -->
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <path
      fill="currentColor"
      d="M11.5 22h-.4c-.1 0-.3-.1-.4-.2l-6.5-3.6c-.3-.2-.5-.4-.6-.6-.2-.3-.2-.6-.2-.9v-5.8l-3-1.5C.3 9.3.2 9.2.1 9 0 8.9 0 8.8 0 8.6s0-.3.1-.4l.3-.3 10.3-5.6c.1-.1.3-.1.4-.2.1 0 .3-.1.4-.1.2 0 .3 0 .4.1.1 0 .3.1.4.2l11.2 6.1c.2.1.3.2.3.3.2.1.2.3.2.4v7.6c0 .2-.1.4-.2.6-.2.2-.4.2-.6.2-.2 0-.4-.1-.6-.2-.2-.2-.2-.4-.2-.6V9.6l-2.6 1.3v5.8c0 .3-.1.6-.2.9-.2.3-.4.5-.6.6l-6.5 3.6c-.1.1-.3.1-.4.2-.3-.1-.4 0-.6 0zm0-8.5 8.9-4.9-8.9-4.8-8.9 4.8 8.9 4.9zm0 6.8 6.5-3.6v-4.8L12.3 15c-.1.1-.3.1-.4.2h-.8c-.1 0-.3-.1-.4-.2L5 11.9v4.8l6.5 3.6z"
    />
  </svg>
</template>
